export default __webpack_public_path__ + "static/date-label-do-1-light-5c77b6e291e6a5b7c49298dc9009ebdf.png";